<template>
  <div class="axj-view-club">
    <view-club-header
      @create="handleCreate"
    />
    <view-club-main
      :data="tableData"
      @update="handleUpdate"
      @delete="handleDeleteViewClub"
    />
    <view-club-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <view-club-edit
      @success="handleEditSuccess"
      :viewId="viewClubEdit.viewId"
      :show.sync="viewClubEdit.show"
      :is-create="viewClubEdit.isCreate"
    />
  </div>
</template>

<script>
import ViewClubHeader from "./component/view-club-header/index";
import ViewClubMain from "./component/view-club-main/index";
import ViewClubFooter from "./component/view-club-footer/index";
import {listViewClub,deleteLecturehallSpeech} from "../../../api/axj-information/axj-information-view-club"
import ViewClubEdit from "./action/view-club-edit";
export default {
  name: "axj-view-club",
  components: {ViewClubEdit, ViewClubFooter, ViewClubMain, ViewClubHeader},
  methods:{
    handleUpdate(id){
      this.viewClubEdit.viewId=id
      this.viewClubEdit.isCreate=false
      this.viewClubEdit.show=true
    },
    handleCreate(){
      this.viewClubEdit.isCreate=true
      this.viewClubEdit.show=true
    },
    handleDeleteViewClub(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteLecturehallSpeech(id)
        this.initData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    handleEditSuccess(){
      this.viewClubEdit.show=false
      this.initData()
    },
    initData(){
      let user=this.$store.getters.getUser
      listViewClub({
        ...this.page,
        where:JSON.stringify({
          user_id:user.uid
        }),
      }).then(res=>{
        console.log(res)
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
      },error => {
        console.log(error)
      })
    },
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  data(){
    return{
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      viewClubEdit:{
        show:false,
        isCreate:false
      }
    }
  }
}
</script>

<style slot-scope lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-view-club/index.vue